import Folder from '../store/schema/Folder';
import getMailboxRootFolder from './getMailboxRootFolder';

/**
 * Shared folders root folder selector for a given user
 */
export default function getSharedFolderRoot(principalSMTPAddress: string): Folder {
    return getMailboxRootFolder(principalSMTPAddress);
}
